<div class="w-full chip-info" [formGroup]="formGroup()">
  <div class="flex flex-col w-full">
    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="vetId" id="vet-select" optionLabel="name" optionValue="id" required="true" [options]="vets()" (onChange)="changeVeterinarian($event)">\
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('vetId')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name }} {{ selectedOption.surname }}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-vet>
                    <div class="flex items-center gap-2">
                        {{ vet.name }} {{ vet.surname }}
                    </div>
                </ng-template>
            </p-select>
            <label for="vet-select">{{ "chipRegistration.microchip.vetSelect" | translate }}*</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <input class="w-64" formControlName="selectedVetDocumentId" id="selectedVetDocumentId" pInputText readonly="true" required="true" type="text" />
            <label for="selectedVetDocumentId">{{ 'chipRegistration.microchip.vetId' | translate }}*</label>
        </p-floatlabel>


        <p-floatlabel variant="in">
            <p-datepicker class="w-64" formControlName="date" id="dateOfRegistration" showIcon="true" [disabled]="true" [readonlyInput]="true" [required]="true" />
            <label for="dateOfRegistration">{{ (isRegistration() ? 'chipRegistration.microchip.registrationDate' : 'chipRegistration.microchip.currentDate') | translate }}*</label>
        </p-floatlabel>

    </div>
    <div class="flex flex-row items-center gap-2">
        <p-checkbox formControlName="chipReaded" inputId="chipReaded" [binary]="true" [required]="true" />
        <label for="chipReaded">{{ "chipRegistration.microchip.chipReadQuestion" | translate }}*</label>
    </div>
  </div>
</div>

